var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgOpeningQuote = function SvgOpeningQuote(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 45,
    height: 31,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M.616 30.816v-6.082c0-2.027.044-3.91.13-5.647.26-6.082 1.43-10.68 3.51-13.793C6.334 2.108 10.232.515 15.951.515l1.69 5.213c-3.207.145-5.286 1.123-6.239 2.933-.953 1.81-1.43 4.271-1.43 7.385h8.578v14.77H.616Zm25.863 0v-6.082c0-2.027.043-3.91.13-5.647.26-6.082 1.429-10.68 3.508-13.793C32.197 2.108 36.096.515 41.814.515l1.69 5.213c-3.206.145-5.286 1.123-6.239 2.933-.953 1.81-1.43 4.271-1.43 7.385h8.578v14.77H26.48Z",
    fill: "#333"
  })));
};
export default SvgOpeningQuote;